import { render, staticRenderFns } from "./TermosUso.vue?vue&type=template&id=c37389d0&scoped=true"
import script from "./TermosUso.vue?vue&type=script&lang=js"
export * from "./TermosUso.vue?vue&type=script&lang=js"
import style0 from "./TermosUso.vue?vue&type=style&index=0&id=c37389d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37389d0",
  null
  
)

export default component.exports